import React from 'react'
import { STATIC_IMAGE_BASE } from '@mc/constants'

export const InstructorFaceStack = ({ className }: { className?: string }) => (
  <img
    src={`${STATIC_IMAGE_BASE}/CM_instructors_hero_2x.png`}
    alt=''
    width={183}
    height={38}
    className={className}
  />
)
